export default __webpack_public_path__ + "static/thebottomline6-7fc1c357aa324ed31e3ec01eb0056ada.jpg";